import React, { Component, ReactNode, ErrorInfo } from "react";

interface Props {
  children?: ReactNode;
}

type State = { error?: Error };

export class ErrorBoundary extends Component<Props, State> {
  // Explicitly declare state property
  public state: State = {};
  // Explicitly declare props to avoid TS errors
  public readonly props: Readonly<Props>;

  constructor(props: Props) {
    super(props);
    this.props = props;
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="container">
          <div className="card">
            <h1 className="h1">應用程式發生錯誤</h1>
            <p className="p">系統攔截到異常。為避免畫面全黑，請查看以下錯誤訊息以進行除錯。</p>
            <div className="err">
              {this.state.error.message}
              {"\n\n"}
              {this.state.error.stack || ""}
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}